module.exports = __webpack_public_path__ + "static/hip-cap-1-7bf13722eebc756a033aa887cc16143d.jpg";